import React, { useEffect, useState } from "react";
import { ALERT_STATUS_TO_DISPLAY_NAME, AlertTickData, IAlertReviewAttachment } from "../../../types/api/AlertTypes";
import Table from "react-bootstrap/Table";
import { formatDate } from "../../../services/utils";
import { fetchAlertReviewAttachments } from '../../../redux-store/actions/fetchAlertReviewAttachments';

interface AlertLastReviewProps {
    alert: AlertTickData
    accessTokenV2: string
}

const AlertLastReview = ({alert, accessTokenV2}: AlertLastReviewProps) => {
    const [attachments, setAttachments] = useState<IAlertReviewAttachment[]>([]);

    useEffect(() => {
        async function loadAttachments() {
            if (alert.review_id && alert.adu_groupid) {
            const data = await fetchAlertReviewAttachments(alert.review_id, alert.adu_groupid, accessTokenV2);
            setAttachments(data);
            }
        }
        loadAttachments();
    }, [alert.review_id, alert.adu_groupid]);

    return (
        <div>
            <Table className='SimpleCompressedTable'>
                <tbody>
                    <tr>
                        <th>User</th>
                        <td>{alert.adu_username}</td>
                    </tr>
                    <tr>
                        <th>Comment time</th>
                        <td>{formatDate(alert.comment_timestamp)}</td>
                    </tr>
                    <tr>
                        <th>Comment</th>
                        <td>
                            {alert.alert_comment?.split('\n')?.map(words => (
                                <p key={words}>{words}</p>
                            ))}
                        </td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td>{ALERT_STATUS_TO_DISPLAY_NAME[alert.status ?? 'forreview']}</td>
                    </tr>
                    <tr>
                        <th>Attachment</th>
                        <td>
                            {attachments.length === 0 && <span>No attachments</span>}
                            {attachments.length > 0 && (
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {attachments.map((file, idx) => (
                                        <li key={file.s3_key || idx} style={{ marginBottom: 4 }}>
                                            <a
                                                href={file.url || '#'}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download={file.filename}
                                                title={file.filename}
                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5em' }}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 16V4M12 16l-4-4M12 16l4-4M4 20h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                                {file.filename} {file.file_size_bytes ? `(${Math.round(file.file_size_bytes/1024)} KB)` : ''}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    )
}

export default AlertLastReview;